
























import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {}
})
export default class InvestmentHeaderWithLogo extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop({required: true})
  title: string;

  @Prop({required: true})
  showLogo: boolean;


  @Prop({required: true})
  showTitle: boolean;

  get imgSrc (): string {
    return this.custodianSettingsStore.isHsaBankCustodian ?
      "img/LH_Logo_Round_dark.png" : "img/abg-logo.png";
  }

  get imgAltText (): string {
    return this.custodianSettingsStore.isHsaBankCustodian ?
      "Leafhouse Logo" : "ABG Consulting";
  }
}
